import React from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';
import { Hide } from 'pcln-design-system';
import styled from 'styled-components';
var FullHeightInView = styled(InView).withConfig({
  displayName: "RenderInView__FullHeightInView",
  componentId: "sc-g8x4r6-0"
})(["height:100%;"]);
var RenderInView = function RenderInView(_ref) {
  var children = _ref.children,
    onSlideChange = _ref.onSlideChange,
    index = _ref.index,
    displayArrowsMobile = _ref.displayArrowsMobile;
  var slideVisible = function slideVisible(inView) {
    if (inView) {
      onSlideChange(index);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, displayArrowsMobile === true ? /*#__PURE__*/React.createElement(Hide, {
    md: true,
    lg: true,
    xl: true,
    xxl: true,
    height: "100%"
  }, /*#__PURE__*/React.createElement(FullHeightInView, {
    onChange: slideVisible
  }, children)) : null, /*#__PURE__*/React.createElement(Hide, {
    xs: true,
    sm: true,
    height: "100%"
  }, children));
};
RenderInView.propTypes = {
  onSlideChange: PropTypes.func,
  index: PropTypes.number
};
export { RenderInView };